import { Action } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import { useSelector, useDispatch, TypedUseSelectorHook } from 'react-redux';
import { store, persistor } from './store';
import rootReducer from './rootReducer';

export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;
export type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { store, rootReducer, persistor };
